import * as deviceData from 'mobile-device-detect';

export default (client, defaultParams) => ({
  create: (payload) => (
    client('/event', {
      method: 'POST',
      data: {
        ...payload,
        _d: deviceData,
        _screen: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      },
      params: {
        ...defaultParams,
      },
    })
  ),
});
